import { gql } from 'apollo-boost'

const DOCUMENT_MENU_SCRAPING_JOB = gql`
  query documentMenuScrapingJob($id: ID!) {
    documentMenuScrapingJob(id: $id) {
      id
      createdDate
      completedDate
      documentMenuScrapingResponse {
        id
        data
      }
    }
  }
`

export default DOCUMENT_MENU_SCRAPING_JOB
